export const periodOptions = [
  { label: "monthlyLabel", value: "MONTHLY" },
  { label: "annuallyLabel", value: "ANNUALLY" },
];

export const billingPeriods = [
  { label: "previousMonthLabel", value: "PREVIOUS_MONTH" },
  { label: "currentMonthLabel", value: "CURRENT_MONTH" },
];

export const ebillingYearOptions = [
  { label: "previousYearLabel", value: "PREVIOUS_YEAR" },
  { label: "currentYearLabel", value: "CURRENT_YEAR" },
];
